import React, { useEffect, useMemo } from 'react'
import Dropdown from '../Dropdown/Dropdown'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import { HStack, Skeleton, VStack } from '@chakra-ui/react'

const BlueprintList = observer(() => {
  const {
    wizardStore: {
      fetchBlueprintList,
      loadingBlueprints,
      availableBlueprints,
      setSelectedBlueprint,
    },
  } = rootStore

  useEffect(() => {
    fetchBlueprintList()
  }, [fetchBlueprintList])

  const handleBlueprintChange = blueprintId => {
    setSelectedBlueprint(blueprintId.value)
  }

  const dropdownBlueprintItems = useMemo(() => {
    return availableBlueprints?.length > 0
      ? availableBlueprints.map((blueprint, blueprintIdx) => ({
          label: blueprint.name,
          id: `${blueprintIdx}`,
          value: blueprint.id,
        }))
      : [{ label: 'No blueprints found', id: '-1', value: '-1' }]
  }, [availableBlueprints])

  if (loadingBlueprints) {
    return <Loading />
  }

  return (
    <Dropdown
      onChange={option => handleBlueprintChange(option)}
      items={dropdownBlueprintItems}
    />
  )
})

const Loading = () => {
  const colorProps = {
    startColor: 'brand.lightGray',
    endColor: 'transparent',
  }
  return (
    <HStack>
      <VStack w="30%">
        <Skeleton
          w="100%"
          h="50px"
          {...colorProps}
        />
      </VStack>
    </HStack>
  )
}

BlueprintList.propTypes = {}

export default BlueprintList
